import AgeValidationInput from "../../components/AgeValidationInput";
import CustomHeaderTitle from "../../components/constants/CustomHeaderTitle";
import HeaderBread from "../../components/HeaderBread";
import Layout from "../../Layout";

const CreateAgeValidation = () => {
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Age Validation",
      route: "/shore/mobile-masters/age-validation",
    },
    {
      title: "Add Age Validation",
      route: "/shore/mobile-masters/age-validation/add",
    },
  ];

  return (
    <Layout type={"create_per"} module_data={"Age Validation"}>
      <CustomHeaderTitle title={"Create Age Validation"} />
      <HeaderBread
        navigation={navigation}
        title={"Add Age Validation"}
      ></HeaderBread>
      <AgeValidationInput ageValidation={{}} />
    </Layout>
  );
};

export default CreateAgeValidation;
